import React, { useState } from 'react';

import './style.scss';
import { useDispatch } from 'react-redux';
import { AddEventCase } from '../../../store/alerts/actions';


interface Props {

}

const AddCaseComponent: React.FC<Props> = () => {
    const dispatch = useDispatch();
    const [isAddCaseOpen, toggleAddCaseWindow] = useState<boolean>(false);
    const [newCaseName, onNewCaseNameChange] = useState<string>('');
    const [newCaseComment, onNewCaseCommentChange] = useState<string>('');

    const addCaseHandler = () => {
        if (isAddCaseOpen) {
            dispatch(AddEventCase(newCaseName, newCaseComment));
            onNewCaseNameChange('');
            onNewCaseCommentChange('');
        } else {
            toggleAddCaseWindow(!isAddCaseOpen);
        }
    }

    return (
        <div className='alerts__add-case-block'>
            {
                isAddCaseOpen && <div className='event-form__add-case-form'>
                    <input className={'event-form__input'}
                        type="text"
                        placeholder='Case name'
                        value={newCaseName}
                        onChange={(e) => { onNewCaseNameChange(e.target.value) }}
                    />
                    <input className={'event-form__input'}
                        type="text"
                        placeholder='Case comment'
                        value={newCaseComment}
                        onChange={(e) => { onNewCaseCommentChange(e.target.value) }}
                    />
                </div>
            }
            <div className={'event-form__button-row'}>
                {
                    isAddCaseOpen && <button className={'event-form__button cancel'}
                        onClick={() => { toggleAddCaseWindow(!isAddCaseOpen) }}>
                        Cancel
            </button>
                }
                <button className={'event-form__button add-case'}
                    onClick={addCaseHandler}
                    disabled={newCaseName === '' && isAddCaseOpen ? true : false}>Add case</button>
            </div>
        </div>
    );


};

export default AddCaseComponent;